import { gql } from '@apollo/client';

export const ovdTokenFragment = gql`
  fragment OvdTokenInfo on OvdToken {
    tokenId
    label
    platformIds
    shipperIds
    carrierIds
    deliveryCustomFields
    tourCustomFields
    enableStatus
    enableApiEta
    enableCustomFields
    enableCancellationReason
    enableLocation
    createdAt
    updatedAt
  }
`;

export const ovdTokenWithSecretFragment = gql`
  fragment OvdTokenWithSecret on OvdToken {
    ...OvdTokenInfo
    token
  }
  ${ovdTokenFragment}
`;

export const ovdTokensQuery = gql`
  query OvdTokens {
    ovdTokens {
      ...OvdTokenInfo
    }
  }
  ${ovdTokenFragment}
`;

export const ovdTokenQuery = gql`
  query OvdToken($tokenId: String!) {
    ovdToken(tokenId: $tokenId) {
      ...OvdTokenInfo
    }
  }
  ${ovdTokenFragment}
`;

export const createOvdTokenMutation = gql`
  mutation CreateOvdToken($input: CreateOvdTokenInput!) {
    createOvdToken(input: $input) {
      ...OvdTokenWithSecret
    }
  }
  ${ovdTokenWithSecretFragment}
`;

export const updateOvdTokenMutation = gql`
  mutation UpdateOvdToken($input: UpdateOvdTokenInput!) {
    updateOvdToken(input: $input) {
      ...OvdTokenInfo
    }
  }
  ${ovdTokenFragment}
`;

export const deleteOvdTokenMutation = gql`
  mutation DeleteOvdToken($input: DeleteOvdTokenInput!) {
    deleteOvdToken(input: $input)
  }
`;

export const revealOvdTokenMutation = gql`
  mutation RevealOvdToken($tokenId: String!, $captchaToken: String!) {
    revealOvdToken(tokenId: $tokenId, captchaToken: $captchaToken) {
      ...OvdTokenWithSecret
    }
  }
  ${ovdTokenWithSecretFragment}
`;

export const testOvdTokenFilterMutation = gql`
  mutation TestOvdTokenFilter($input: TestOvdTokenFilterInput!) {
    testOvdTokenFilter(input: $input) {
      matchingShipmentCount
      sampleShipments {
        shipmentId
        shipperTransportNumber
        platformTransportNumber
      }
    }
  }
`;
